const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClouds(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 130 120",
    width: 159.805,
    height: 149.013,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 0
    },
    cx: 20.705,
    cy: 79.967,
    rx: 36.021,
    ry: 36.021
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 0
    },
    cx: 53.911,
    cy: 59.198,
    rx: 17.952,
    ry: 17.952
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 0
    },
    cx: 75.852,
    cy: 27.871,
    rx: 37.077,
    ry: 37.077
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 0
    },
    cx: 106.006,
    cy: -0.172,
    rx: 21.354,
    ry: 21.354
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      strokeWidth: 0,
      paintOrder: "stroke",
      stroke: "rgb(109, 109, 109)",
      fill: "rgb(145, 145, 145)"
    },
    cx: 56.375,
    cy: 2.761,
    rx: 35.786,
    ry: 35.786
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      strokeWidth: 0,
      paintOrder: "stroke",
      stroke: "rgb(109, 109, 109)",
      fill: "rgb(145, 145, 145)"
    },
    cx: 34.082,
    cy: 31.626,
    rx: 18.538,
    ry: 18.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      strokeWidth: 0,
      paintOrder: "stroke",
      stroke: "rgb(109, 109, 109)",
      fill: "rgb(145, 145, 145)"
    },
    cx: 1.229,
    cy: 25.524,
    rx: 33.674,
    ry: 33.674
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClouds);
export default __webpack_public_path__ + "static/media/Clouds.a32704c0fd329c9ca07cf10cbca3ef6b.svg";
export { ForwardRef as ReactComponent };